import React, { useState } from "react";
import styles from "./ContactForm.module.css";
import { BRAND } from "../../data/brand";
import { submitLeadForm } from "../../utils/payment";
import { Animate } from "../animations";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitLeadForm(formData, "contact");
    setSubmitted(true);
    setFormData({ name: "", email: "", phone: "", address: "", message: "" });
  };

  return (
    <Animate variant="fadeUp" className={styles.contactContainer}>
      <div className={styles.leftSection}>
        <h2 className={styles.heading}>Contact Form</h2>
        <h1 className={styles.subHeading} id="heading-large">
          Get In Touch
        </h1>
        {submitted ? (
          <div className="bg-green-50 text-green-700 p-6 rounded-lg">
            <h3 className="text-xl font-semibold">Message Sent!</h3>
            <p className="mt-2">We'll get back to you within 24 hours.</p>
          </div>
        ) : (
          <form className={styles.contactform} onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="address"
              placeholder="City / State"
              value={formData.address}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="How can we help you?"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit" className={styles.sendMessageBtn}>
              Send Message
            </button>
          </form>
        )}
      </div>
      <div className={styles.rightSection}>
        <div>
          <h4 className={styles.heading}>Contact Us</h4>
          <h1 id="heading-large" style={{ color: "var(--white)" }}>
            Mailing Address
          </h1>
          <p>
            <i className="fa fa-map-marker"></i> {BRAND.address}
          </p>
          <p>
            <i className="fa fa-phone"></i> {BRAND.phone}
          </p>
          <p>
            <i className="fa fa-envelope"></i> {BRAND.email}
          </p>
          <p>
            <i className="fa fa-whatsapp"></i> WhatsApp: {BRAND.whatsapp}
          </p>
          <p>
            <i className="fa fa-globe"></i> {BRAND.website}
          </p>
        </div>
        <div className={styles.socialIcons}>
          <a href={BRAND.social.facebook} target="_blank" rel="noreferrer">
            <i className="fa fa-facebook"></i>
          </a>
          <a href={BRAND.social.instagram} target="_blank" rel="noreferrer">
            <i className="fa fa-instagram"></i>
          </a>
          <a href={BRAND.social.linkedin} target="_blank" rel="noreferrer">
            <i className="fa fa-linkedin"></i>
          </a>
        </div>
      </div>
    </Animate>
  );
};

export default ContactForm;
